export const OPERATIONS = {
  PREPEND: 'prepend',
  APPEND: 'append',
  INSERT: 'insert',
  REMOVE: 'remove',
  NONE: 'none'
};
